import urljoin from "url-join";

export function urlForCountryCode(targetCountryCode: string, pathname: string, query?: string) {
  const pathParts = pathname.split('/')
  let search = ''
  if (query) {
    search = '?' + query
  }
  return urljoin('/', targetCountryCode, ...pathParts.slice(1)) + search
}

export function urlForReplacedCountryCode(targetCountryCode: string, pathname: string, query?: string) {
  const pathParts = pathname.split('/')
  pathParts[1] = targetCountryCode
  let search = ''
  if (query) {
    search = '?' + query
  }
  return urljoin('/', ...pathParts) + search
}
